import {findIn, closest, on, addClass, removeClass} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";


export function init (scope = document.body) {
    onFind(".js-anchor-nav", (wrapper) => {
        let buttonLeft = findIn('.js-anchor-nav__scroll-btn--left', wrapper);
        let buttonRight = findIn('.js-anchor-nav__scroll-btn--right', wrapper);
        let list = findIn('.js-anchor-nav__list', wrapper);

        // hide buttonRight if list is not scrollable
        if (list.scrollWidth <= list.clientWidth) {
            addClass('d-none', buttonRight);
        } else {
            addClass('anchor-nav__nav--scrollable-right', wrapper);
        }

        const checkScrollPosition = () => {
            if (list.scrollLeft === 0) {
                addClass('d-none', buttonLeft);
                removeClass('anchor-nav__nav--scrollable-left', wrapper);
            } else {
                removeClass('d-none', buttonLeft);
                addClass('anchor-nav__nav--scrollable-left', wrapper);
            }
            if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
                removeClass('anchor-nav__nav--scrollable-right', wrapper);
                addClass('d-none', buttonRight);
            } else {
                removeClass('d-none', buttonRight);
                addClass('anchor-nav__nav--scrollable-right', wrapper);
            }
        };

        checkScrollPosition();
        on('scroll', checkScrollPosition, list);


        on('click', (e) => {
            e.preventDefault();
            list.scrollBy({
                top: 0,
                left: 150,
                behavior: 'smooth'
            });
        }, buttonRight);

        on('click', (e) => {
            e.preventDefault();
            list.scrollBy({
                top: 0,
                left: -150,
                behavior: 'smooth'
            });
        }, buttonLeft);
    }, scope);
}